module.exports = __webpack_public_path__ + "components/flag/static/square/mr-9f282f90ab525a9a98cd54d1077bc13a.svg";